import { notice } from "/assets/js/utils/notices";
import { applyPhoneMask } from "/assets/js/utils/phone-mask";
import AddressSuggestions from "/assets/js/components/address-suggestions/_index.js";
import {nsFetch} from "/assets/js/utils/fetch";

class Checkout {
    form;
    submitOrderBtn;
    fullNameInput;
    firstNameInput;
    lastNameInput;
    phoneInput;
    emailInput;
    promoCodeInput;
    promoCodeApplyBtn;
    checkoutTotal;
    termsAgreement;
    policyAgreement;
    shippingContainer;
    paymentMethods;

    constructor(elm) {
        this.form = elm;

        this.submitOrderBtn =
            this.form.querySelector("#place_order") ||
            this.form.querySelector(".checkout__right-form-item--submit");

        this.fullNameInput = this.form.querySelector('[name="billing_full_name"]');
        this.firstNameInput = this.form.querySelector('[name="billing_first_name"]');
        this.lastNameInput = this.form.querySelector('[name="billing_last_name"]');
        this.phoneInput = this.form.querySelector('[name="billing_phone"]');
        this.emailInput = this.form.querySelector('[name="billing_email"]');

        this.termsAgreement = this.form.querySelector('[name="terms"]');
        this.policyAgreement = this.form.querySelector('[name="policy"]');

        this.deliveryAddressInput = this.form.querySelector('[name="delivery_address"]');
        this.deliveryFloorInput = this.form.querySelector('[name="billing_floor"]');
        this.deliveryFlatInput = this.form.querySelector('[name="billing_flat"]');
        this.deliveryEntranceInput = this.form.querySelector('[name="billing_entrance"]');

        this.wooAddress1Input = this.form.querySelector('[name="billing_address_1"]');
        this.wooAddress2Input = this.form.querySelector('[name="billing_address_2"]');
        this.wooPostcodeInput = this.form.querySelector('[name="billing_postcode"]');
        this.wooCityInput = this.form.querySelector('[name="billing_city"]');
        this.wooStateInput = this.form.querySelector('[name="billing_state"]');
        

        this.addressSuggestions = this.form.querySelector('#address_suggestions');
        this.addressSuggestionsInstance = null;

        this.promoCodeInput = this.form.querySelector('[name="promo_code"]');
        this.promoCodeApplyBtn = this.form.querySelector('#apply_promo');

        this.checkoutTotal = this.form.querySelector('.checkout__left-footer');

        this.paymentMethods = this.form?.querySelectorAll(".payment-method")

        this.init();
        this.initShipping();
    }

    init() {
        this.submitOrderBtn.addEventListener("click", this._submitOrder);

        this.fullNameInput.addEventListener("input", this._fieldChanged);
        this.phoneInput.addEventListener("input", applyPhoneMask);
        this.phoneInput.addEventListener("input", this._fieldChanged);
        this.emailInput.addEventListener("input", this._fieldChanged);

        this.termsAgreement.addEventListener("click", this._fieldChanged);
        this.policyAgreement.addEventListener("click", this._fieldChanged);

        if (this.deliveryAddressInput && this.addressSuggestions) {
            this.addressSuggestionsInstance = new AddressSuggestions(
                this.deliveryAddressInput,
                this.addressSuggestions,
                backendData?.dadataApiKey
            );

            this.deliveryAddressInput.addEventListener('change', this.addressChanged);
        }

        this._toggleDeliveryAddress();

        this.promoCodeApplyBtn.addEventListener('click', this._applyPromo);

        this.paymentMethods.forEach(elm => elm.addEventListener('change', this.paymentChange));

        jQuery(document).ajaxComplete((event, xhr, settings) => {
            // settings.url — URL запроса
            if (settings.url.indexOf('admin-ajax.php?action=edostavka_set_delivery_point') !== -1) {
                this.updateShippingHtml();
            }
        });
    }

    initShipping() {
        this.selectedShipping = this.form?.querySelector(".checkout__shipping-method-input:checked").value;

        this.shippingContainer = this.form?.querySelector("#checkout_shipping");
        this.shippingMethods = this.form?.querySelectorAll(".checkout__shipping-method-input") || [];

        this.shippingMethods.forEach((method) => {
            method.addEventListener("change", this.shippingChange);
        });
    }

    async updateShippingHtml() {
        try {
            const response = await nsFetch.doFetch({
                action: "update_shipping_html",
                body: {
                    update_shipping_html: true,
                },
            });

            if (response.success) {
                this.shippingContainer.outerHTML = response.data.shipping_html;
                this.initShipping();
            } else {
               notice(`Ошибка при обновлении способа доставки.`, "error");
            }
        } catch (error) {
            console.error("Ошибка при обновлении способа доставки:", error);
            notice("Ошибка при обновлении способа доставки", "error");
        } finally {
        }
    }

    paymentChange = async (e) => {
        try {
            const selectedMethod = this.form.querySelector('input[name="payment_method"]:checked').value;
            const response = await nsFetch.doFetch({
                action: "payment_update",
                body: {
                    payment_method: selectedMethod,
                },
            });

            if (response.success) {
                notice(response.data.message, "info");
            } else {
                notice(`Ошибка при обновлении способа оплаты.`, "error");
            }
        } catch (error) {
            console.error("Ошибка при обновлении способа оплаты:", error);
            notice("Ошибка при обновлении способа оплаты", "error");
        } finally {
        }
    }

    addressChanged = async (e) => {
        const dataSet = this.deliveryAddressInput.dataset;

        this.wooAddress1Input.value = dataSet.address ? dataSet.address : '';
        this.wooPostcodeInput.value = dataSet.postcode ? dataSet.postcode : '';
        this.wooCityInput.value = dataSet.city ? dataSet.city : '';
        this.wooStateInput.value = dataSet.state ? dataSet.state : '';

        //await this.wooDevSetLocation();

        await this.requestShippingMethods(this.selectedShipping);
    }

    async wooDevSetLocation() {
        const formData = new FormData();
        formData.append('customer_id', this.submitOrderBtn.dataset.userId);
        formData.append('location[city]', this.wooCityInput.value);
        formData.append('location[country_code]', 'RU');
        formData.append('location[country]', 'Россия');
        formData.append('location[region]', this.wooStateInput.value);
        formData.append('location[fias_guid]', this.deliveryAddressInput.dataset.cityFiasId);


        fetch(`${backendData.siteUrl}?wc-ajax=edostavka_set_customer_location`, {
            method: "POST",
            body: formData,
        })
        .then((resp) => resp.json())
        .then((data) => {
            console.log(data);
        })
        .catch(() => {
            notice("Что-то пошло не так, попробуйте еще раз", "error");
        })
        .finally(() => {
            
        });
    }

    async requestShippingMethods(selectedMethod) {
        this.shippingContainer.classList.add('is-loading');
        this.checkoutTotal.classList.add('is-loading');
        //jQuery(document.body).trigger('update_checkout');
        
        try {
            const response = await nsFetch.doFetch({
                action: "checkout_update",
                body: {
                    shipping_method: selectedMethod,
                    address_data: this.collectAddressData(),
                },
            });

            if (response.success) {
                this.shippingContainer.outerHTML = response.data.shipping_html;
                this.checkoutTotal.innerHTML = response.data.checkout_total_html;

                this.initShipping();
            } else {
               notice(`Ошибка при обновлении способа доставки.`, "error");
            }
        } catch (error) {
            console.error("Ошибка при обновлении способа доставки:", error);
            notice("Ошибка при обновлении способа доставки", "error");
        } finally {
            this.shippingContainer.classList.remove('is-loading');
            this.checkoutTotal.classList.remove('is-loading');
        }
        
    }

    shippingChange = async (e) => {
        this.selectedShipping = e.target.value;
        const selectedMethod = e.target.value;

        if (selectedMethod.indexOf('local_pickup') >= 0) {
            this.deliveryAddressInput.required = false;
            this.deliveryAddressInput.classList.remove("invalid");
            document.querySelector('.checkout__right-form-item--delivery').classList.remove('required');
        } else {
            this.deliveryAddressInput.required = true;
            document.querySelector('.checkout__right-form-item--delivery').classList.add('required');
        }

        await this.requestShippingMethods(selectedMethod);
    }

    collectAddressData() {
        return {
            address_1: this.wooAddress1Input.value,
            city: this.wooCityInput.value,
            state: this.wooStateInput.value,
            postcode: this.wooPostcodeInput.value,
        }
    }

    fillAddress2Input() {
        let address2 = '';

        if (this.deliveryFlatInput.value != '') {
            address2 = 'кв. ' + this.deliveryFlatInput.value;
        }

        if (this.deliveryFloorInput.value != '') {
            address2 = 'этаж ' + this.deliveryFloorInput.value + ', ' + address2;
        }

        if (this.deliveryEntranceInput.value != '') {
            address2 = 'подъезд ' + this.deliveryEntranceInput.value + ', ' + address2;
        }

        this.wooAddress2Input.value = address2;
    }

    _applyPromo = async (e) => {
        e.preventDefault();
        console.log('_applyPromo click');

        this.promoCodeApplyBtn.classList.add('is-loading');
        this.checkoutTotal.classList.add('is-loading');

        let action = 'apply_promo';
        const formData = new FormData();
        formData.append('promo_code', this.promoCodeInput.value);

        if (this.promoCodeInput.disabled) {
            action = 'remove_promo';
        }

        fetch(`${backendData.siteUrl}?wc-ajax=${action}`, {
            method: "POST",
            body: formData,
        })
        .then((resp) => resp.json())
        .then((data) => {
            if (data.success) {
                notice(data.data.message, 'info');

                if (action == 'apply_promo') {
                    this.promoCodeInput.disabled = true;
                    this.promoCodeApplyBtn.textContent = 'Удалить';
                } else {
                    this.promoCodeInput.disabled = false;
                    this.promoCodeInput.value = '';
                    this.promoCodeApplyBtn.textContent = 'Применить';
                }

                this.checkoutTotal.innerHTML = data.data.checkout_total_html;
            } else {
                notice(data.data.message, "error");
            }
        })
        .catch(() => {
            notice("Что-то пошло не так, попробуйте еще раз", "error");
        })
        .finally(() => {
            this.promoCodeApplyBtn.classList.remove('is-loading');
            this.checkoutTotal.classList.remove('is-loading');
        });
    }

    _submitOrder = async (e) => {
        e.preventDefault();

        let formValidated = true;
        let firstInvalidNotice = false;

        if (this.fullNameInput.value == "") {
            this.fullNameInput.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Введите Имя и фамилию", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.fullNameInput.classList.remove("invalid");
        }

        if (!this.validatePhone(this.phoneInput.value)) {
            this.phoneInput.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Введите номер телефона", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.phoneInput.classList.remove("invalid");
        }

        if (!this.validateEmail(this.emailInput.value)) {
            this.emailInput.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Введите Email", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.emailInput.classList.remove("invalid");
        }

        if (this.deliveryAddressInput.value == '' && this.deliveryAddressInput.required) {
            this.deliveryAddressInput.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Введите адрес", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.deliveryAddressInput.classList.remove("invalid");
        }

        if (this.wooAddress1Input.value == '' && this.deliveryAddressInput.required ) {
            this.deliveryAddressInput.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Добавте в адрес улицу и номер дома после города", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.deliveryAddressInput.classList.remove("invalid");
        }

        if (!this.policyAgreement.checked) {
            const checkElm = this.policyAgreement.nextElementSibling;
            checkElm.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Подтвердите согласие c политикой конфиденциальности", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            const checkElm = this.policyAgreement.nextElementSibling;
            checkElm.classList.remove("invalid");
        }

        if (!this.termsAgreement.checked) {
            const checkElm = this.termsAgreement.nextElementSibling;
            checkElm.classList.add("invalid");
            if (!firstInvalidNotice) {
                notice("Подтвердите согласие c публичной офертой", "error");
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            const checkElm = this.termsAgreement.nextElementSibling;
            checkElm.classList.remove("invalid");
        }

        if (!formValidated) {
            return;
        }

        // Добавляем прелоадер
        if (this.submitOrderBtn) {
            this.submitOrderBtn.classList.add("is-loading");
        }

        this.fillAddress2Input();

        this.parseFullNameInput();
        const formData = new FormData(this.form);

        fetch(`${backendData.siteUrl}?wc-ajax=checkout`, {
            method: "POST",
            body: formData,
        })
        .then((resp) => resp.json())
        .then((data) => {
            if (data.redirect) {
                window.location.href = data.redirect;
            }

            if (data.messages) {
                notice(
                    data.messages,
                    data.result === "success" ? "default" : "error"
                );
                // Убираем прелоадер при ошибке
                if (this.submitOrderBtn) {
                    this.submitOrderBtn.classList.remove("is-loading");
                }
            }
        })
        .catch(() => {
            // Убираем прелоадер при ошибке
            if (this.submitOrderBtn) {
                this.submitOrderBtn.classList.remove("is-loading");
            }
        });
    };

    _fieldChanged = (e) => {
        const input = e.target;

        if (
            input.getAttribute("name") == "billing_full_name" &&
            input.value != ""
        ) {
            input.classList.remove("invalid");
        }

        if (
            input.getAttribute("name") == "billing_phone" &&
            this.validatePhone(input.value)
        ) {
            input.classList.remove("invalid");
        }

        if (
            input.getAttribute("name") == "billing_email" &&
            this.validateEmail(input.value)
        ) {
            input.classList.remove("invalid");
        }

        if (
            (input.getAttribute("name") == "policy" ||
                input.getAttribute("name") == "terms") &&
            input.checked
        ) {
            const checkElm = input.nextElementSibling;
            checkElm.classList.remove("invalid");
        }
    };

    parseFullNameInput() {
        const nameParts = this.fullNameInput.value.split(/\s+/);
        this.firstNameInput.value = nameParts[0] || "";
        this.lastNameInput.value = nameParts[1] || "";
    }

    validatePhone(phone) {
        if (!phone) return false;

        const cleaned = phone.replace(/[^\d+]/g, "");

        // от 10 до 15 цифр (международный формат)
        return /^\+?\d{10,15}$/.test(cleaned);
    }

    validateEmail(email) {
        if (!email) return false;

        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    validateAddress() {
        if (
            (this.wooAddress1Input == '') ||
            (this.wooCityInput == '') ||
            (this.wooPostcodeInput == '')
        ) {
            return false;
        } else {
            return false;
        }
    }

    _toggleDeliveryAddress() {
        const deliveryTypes = this.form.querySelectorAll("[data-delivery-type]");
        const deliveryContents = this.form.querySelectorAll(
            "[data-delivery-content]"
        );

        deliveryTypes.forEach((deliveryType) => {
            const deliveryTypeValue = deliveryType.dataset.deliveryType;

            deliveryType.addEventListener("click", (e) => {
                deliveryContents.forEach((deliveryContent) => {
                    deliveryContent.classList.remove("active");
                });
                const curDeliveryTypeValue = e.currentTarget.dataset.deliveryType;
                const deliveryContent = e.currentTarget
                    .closest(".checkout__right-form-item")
                    .querySelector(`[data-delivery-content="${curDeliveryTypeValue}"]`);

                if (
                    deliveryContent &&
                    e.currentTarget.querySelector('input[type="radio"]:checked') &&
                    curDeliveryTypeValue == deliveryTypeValue
                ) {
                    deliveryContent.classList.add("active");
                }
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const elm = document.querySelector(".checkout__wrapper");
    if (elm) {
        new Checkout(elm);
    }
});
